export const MIN_LABEL = 'No min';
export const MAX_LABEL = 'No max';

export type SelectOptionType = {
    value: string;
    label: string;
};
export const getMotorsPriceFilterOptions = (isMin: boolean): SelectOptionType[] => {
    return [
        isMin ? { value: MIN_LABEL, label: MIN_LABEL } : { value: MAX_LABEL, label: MAX_LABEL },
        { value: '0', label: '£0' },
        { value: '500', label: '£500' },
        { value: '1000', label: '£1,000' },
        { value: '1500', label: '£1,500' },
        { value: '2000', label: '£2,000' },
        { value: '2500', label: '£2,500' },
        { value: '3000', label: '£3,000' },
        { value: '3500', label: '£3,500' },
        { value: '4000', label: '£4,000' },
        { value: '4500', label: '£4,500' },
        { value: '5000', label: '£5,000' },
        { value: '5500', label: '£5,500' },
        { value: '6000', label: '£6,000' },
        { value: '6500', label: '£6,500' },
        { value: '7000', label: '£7,000' },
        { value: '7500', label: '£7,500' },
        { value: '8000', label: '£8,000' },
        { value: '8500', label: '£8,500' },
        { value: '9000', label: '£9,000' },
        { value: '9500', label: '£9,500' },
        { value: '10000', label: '£10,000' },
        { value: '11000', label: '£11,000' },
        { value: '12000', label: '£12,000' },
        { value: '13000', label: '£13,000' },
        { value: '14000', label: '£14,000' },
        { value: '15000', label: '£15,000' },
        { value: '16000', label: '£16,000' },
        { value: '17000', label: '£17,000' },
        { value: '18000', label: '£18,000' },
        { value: '19000', label: '£19,000' },
        { value: '20000', label: '£20,000' },
        { value: '22500', label: '£22,500' },
        { value: '25000', label: '£25,000' },
        { value: '27500', label: '£27,500' },
        { value: '30000', label: '£30,000' },
        { value: '35000', label: '£35,000' },
        { value: '40000', label: '£40,000' },
        { value: '45000', label: '£45,000' },
        { value: '50000', label: '£50,000' },
        { value: '55000', label: '£55,000' },
        { value: '60000', label: '£60,000' },
        { value: '65000', label: '£65,000' },
        { value: '70000', label: '£70,000' },
        { value: '75000', label: '£75,000' },
        { value: '100000', label: '£100,000' },
        { value: '250000', label: '£250,000' },
        { value: '500000', label: '£500,000' },
        { value: '1000000', label: '£1,000,000' },
        { value: '2000000', label: '£2,000,000' },
    ];
};

export const getJobsPriceFilterOptions = (isMin: boolean): SelectOptionType[] => {
    return [
        isMin ? { value: MIN_LABEL, label: MIN_LABEL } : { value: MAX_LABEL, label: MAX_LABEL },
        { value: '10000', label: '£10,000' },
        { value: '12000', label: '£12,000' },
        { value: '14000', label: '£14,000' },
        { value: '16000', label: '£16,000' },
        { value: '18000', label: '£18,000' },
        { value: '20000', label: '£20,000' },
        { value: '22000', label: '£22,000' },
        { value: '24000', label: '£24,000' },
        { value: '26000', label: '£26,000' },
        { value: '28000', label: '£28,000' },
        { value: '30000', label: '£30,000' },
        { value: '32000', label: '£32,000' },
        { value: '34000', label: '£34,000' },
        { value: '36000', label: '£36,000' },
        { value: '38000', label: '£38,000' },
        { value: '40000', label: '£40,000' },
        { value: '42000', label: '£42,000' },
        { value: '44000', label: '£44,000' },
        { value: '46000', label: '£46,000' },
        { value: '48000', label: '£48,000' },
        { value: '50000', label: '£50,000' },
        { value: '55000', label: '£55,000' },
        { value: '60000', label: '£60,000' },
        { value: '65000', label: '£65,000' },
        { value: '70000', label: '£70,000' },
        { value: '75000', label: '£75,000' },
        { value: '80000', label: '£80,000' },
        { value: '85000', label: '£85,000' },
        { value: '90000', label: '£90,000' },
        { value: '95000', label: '£95,000' },
        { value: '100000', label: '£100,000' },
    ];
};

export const getRentPricePriceFilterOptions = (isMin: boolean): SelectOptionType[] => {
    return [
        isMin ? { value: MIN_LABEL, label: MIN_LABEL } : { value: MAX_LABEL, label: MAX_LABEL },
        { value: '25', label: '£25 pcw' },
        { value: '50', label: '£50 pcw' },
        { value: '75', label: '£75 pcw' },
        { value: '100', label: '£100 pcw' },
        { value: '125', label: '£125 pcw' },
        { value: '150', label: '£150 pcw' },
        { value: '175', label: '£175 pcw' },
        { value: '200', label: '£200 pcw' },
        { value: '225', label: '£225 pcw' },
        { value: '250', label: '£250 pcw' },
        { value: '275', label: '£275 pcw' },
        { value: '300', label: '£300 pcw' },
        { value: '325', label: '£325 pcw' },
        { value: '350', label: '£350 pcw' },
        { value: '375', label: '£375 pcw' },
        { value: '400', label: '£400 pcw' },
        { value: '425', label: '£425 pcw' },
        { value: '450', label: '£450 pcw' },
        { value: '475', label: '£475 pcw' },
        { value: '500', label: '£500 pcw' },
        { value: '550', label: '£550 pcw' },
        { value: '600', label: '£600 pcw' },
        { value: '650', label: '£650 pcw' },
        { value: '700', label: '£700 pcw' },
        { value: '750', label: '£750 pcw' },
        { value: '800', label: '£800 pcw' },
        { value: '850', label: '£850 pcw' },
        { value: '900', label: '£900 pcw' },
        { value: '950', label: '£950 pcw' },
        { value: '1000', label: '£1,000 pcw' },
        { value: '1250', label: '£1,250 pcw' },
        { value: '1500', label: '£1,500 pcw' },
        { value: '1750', label: '£1,750 pcw' },
        { value: '2000', label: '£2,000 pcw' },
        { value: '2500', label: '£2,500 pcw' },
        { value: '3000', label: '£3,000 pcw' },
        { value: '3500', label: '£3,500 pcw' },
        { value: '4000', label: '£4,000 pcw' },
        { value: '4500', label: '£4,500 pcw' },
        { value: '5000', label: '£5,000 pcw' },
        { value: '7500', label: '£7,500 pcw' },
    ];
};

export const getSalePricePriceFilterOptions = (isMin: boolean): SelectOptionType[] => {
    return [
        isMin ? { value: MIN_LABEL, label: MIN_LABEL } : { value: MAX_LABEL, label: MAX_LABEL },
        { value: '10000', label: '£10,000' },
        { value: '20000', label: '£20,000' },
        { value: '30000', label: '£30,000' },
        { value: '40000', label: '£40,000' },
        { value: '50000', label: '£50,000' },
        { value: '60000', label: '£60,000' },
        { value: '70000', label: '£70,000' },
        { value: '80000', label: '£80,000' },
        { value: '90000', label: '£90,000' },
        { value: '100000', label: '£100,000' },
        { value: '110000', label: '£110,000' },
        { value: '120000', label: '£120,000' },
        { value: '125000', label: '£125,000' },
        { value: '130000', label: '£130,000' },
        { value: '140000', label: '£140,000' },
        { value: '150000', label: '£150,000' },
        { value: '160000', label: '£160,000' },
        { value: '170000', label: '£170,000' },
        { value: '180000', label: '£180,000' },
        { value: '190000', label: '£190,000' },
        { value: '200000', label: '£200,000' },
        { value: '210000', label: '£210,000' },
        { value: '220000', label: '£220,000' },
        { value: '230000', label: '£230,000' },
        { value: '240000', label: '£240,000' },
        { value: '250000', label: '£250,000' },
        { value: '275000', label: '£275,000' },
        { value: '300000', label: '£300,000' },
        { value: '325000', label: '£325,000' },
        { value: '350000', label: '£350,000' },
        { value: '375000', label: '£375,000' },
        { value: '400000', label: '£400,000' },
        { value: '425000', label: '£425,000' },
        { value: '450000', label: '£450,000' },
        { value: '475000', label: '£475,000' },
        { value: '500000', label: '£500,000' },
        { value: '550000', label: '£550,000' },
        { value: '600000', label: '£600,000' },
        { value: '650000', label: '£650,000' },
        { value: '700000', label: '£700,000' },
        { value: '750000', label: '£750,000' },
        { value: '800000', label: '£800,000' },
        { value: '850000', label: '£850,000' },
        { value: '900000', label: '£900,000' },
        { value: '950000', label: '£950,000' },
        { value: '1000000', label: '£1,000,000' },
        { value: '1100000', label: '£1,100,000' },
        { value: '1200000', label: '£1,200,000' },
        { value: '1300000', label: '£1,300,000' },
        { value: '1400000', label: '£1,400,000' },
        { value: '1500000', label: '£1,500,000' },
        { value: '1600000', label: '£1,600,000' },
        { value: '1700000', label: '£1,700,000' },
        { value: '1800000', label: '£1,800,000' },
        { value: '1900000', label: '£1,900,000' },
        { value: '2000000', label: '£2,000,000' },
        { value: '2100000', label: '£2,100,000' },
        { value: '2200000', label: '£2,200,000' },
        { value: '2300000', label: '£2,300,000' },
        { value: '2400000', label: '£2,400,000' },
        { value: '2500000', label: '£2,500,000' },
        { value: '2750000', label: '£2,750,000' },
        { value: '3000000', label: '£3,000,000' },
        { value: '3250000', label: '£3,250,000' },
        { value: '3500000', label: '£3,500,000' },
        { value: '3750000', label: '£3,750,000' },
        { value: '4000000', label: '£4,000,000' },
        { value: '4250000', label: '£4,250,000' },
        { value: '4500000', label: '£4,500,000' },
        { value: '4750000', label: '£4,750,000' },
        { value: '5000000', label: '£5,000,000' },
        { value: '5500000', label: '£5,500,000' },
        { value: '6000000', label: '£6,000,000' },
        { value: '6500000', label: '£6,500,000' },
        { value: '7000000', label: '£7,000,000' },
        { value: '7500000', label: '£7,500,000' },
        { value: '8000000', label: '£8,000,000' },
        { value: '8500000', label: '£8,500,000' },
        { value: '9000000', label: '£9,000,000' },
        { value: '9500000', label: '£9,500,000' },
        { value: '10000000', label: '£10,000,000' },
        { value: '12500000', label: '£12,500,000' },
        { value: '15000000', label: '£15,000,000' },
    ];
};
